import { defineFurniture } from './types.js';

/**
 * Rare furniture, sold only for Gold or Diamonds. `price` stays zero so the
 * Kaki Dollar shop never lists them; `premium` carries the real price.
 *
 * These carry an `effect`: an animation the client draws
 * on top of the sprite. The dragons come in colours, and the rarer the colour
 * the higher the price.
 */
export const RARE_FURNITURE = defineFurniture('rare', {
  golden_cat: {
    label: 'Golden Lucky Cat',
    description: 'Its paw never stops waving. Fortune follows.',
    price: 0,
    premium: { currency: 'gold', price: 400 },
    solid: true,
    height: 0.9,
    effect: { type: 'sparkle', color: '#ffe27a', height: 34 },
  },
  gold_throne: {
    label: 'Golden Throne',
    description: 'Sit like the towkay you are.',
    price: 0,
    premium: { currency: 'gold', price: 1500 },
    solid: false,
    seat: 'facing',
    height: 0.6,
    effect: { type: 'sparkle', color: '#ffe27a', height: 40 },
  },
  diamond_throne: {
    label: 'Diamond Throne',
    description: 'Cut from a single diamond. Everyone else stands.',
    price: 0,
    premium: { currency: 'diamond', price: 40 },
    solid: false,
    seat: 'facing',
    height: 0.6,
    effect: { type: 'sparkle', color: '#8fe3ff', color2: '#ffffff', height: 40 },
  },
  diamond_fountain: {
    label: 'Diamond Fountain',
    description: 'Sparkling water over cut diamonds.',
    price: 0,
    premium: { currency: 'diamond', price: 15 },
    solid: true,
    height: 1.2,
    effect: { type: 'spray', color: '#9fe3ff', color2: '#ffffff', height: 44 },
  },
  crystal_pillar: {
    label: 'Crystal Pillar',
    description: 'A glowing column of pure crystal.',
    price: 0,
    premium: { currency: 'diamond', price: 30 },
    solid: true,
    height: 2,
    effect: { type: 'glow', color: '#7fdcff', height: 48 },
  },
  dragon_red: {
    label: 'Flaming Dragon (Red)',
    description: 'A fire-breathing dragon lamp. The classic.',
    price: 0,
    premium: { currency: 'diamond', price: 20 },
    solid: true,
    height: 1.4,
    effect: { type: 'flames', color: '#ff5a1f', color2: '#ffd23a', height: 62 },
  },
  dragon_blue: {
    label: 'Flaming Dragon (Blue)',
    description: 'Cold blue flames that burn just as hot.',
    price: 0,
    premium: { currency: 'diamond', price: 25 },
    solid: true,
    height: 1.4,
    effect: { type: 'flames', color: '#2f8bff', color2: '#b8f0ff', height: 62 },
  },
  dragon_green: {
    label: 'Flaming Dragon (Green)',
    description: 'Jade scales and emerald fire.',
    price: 0,
    premium: { currency: 'diamond', price: 25 },
    solid: true,
    height: 1.4,
    effect: { type: 'flames', color: '#2fcf5a', color2: '#eaff8a', height: 62 },
  },
  dragon_purple: {
    label: 'Flaming Dragon (Purple)',
    description: 'Royal purple flames. Very hard to find.',
    price: 0,
    premium: { currency: 'diamond', price: 35 },
    solid: true,
    height: 1.4,
    effect: { type: 'flames', color: '#a04bff', color2: '#f0c8ff', height: 62 },
  },
  door_laser: {
    label: 'Laser Door',
    description: 'A shimmering red barrier. Click it to power it down or back up. Rotate to change direction.',
    price: 0,
    premium: { currency: 'diamond', price: 25 },
    solid: true,
    height: 2.2,
    interaction: { type: 'door' },
  },
  dragon_black: {
    label: 'Flaming Dragon (Black)',
    description: 'Shadow scales, white-hot flames. The rarest of the pack.',
    price: 0,
    premium: { currency: 'diamond', price: 60 },
    solid: true,
    height: 1.4,
    effect: { type: 'flames', color: '#e8e8ff', color2: '#7a5cff', height: 62 },
  },
});
